import BaseApiService from './api.base.service'

class DocumentTypesApiService extends BaseApiService {
  constructor() {
    super('documentTypes')
  }

  getImageTypes(documentTypeId) {
    return this.callGet(`${documentTypeId}/imagetypes`)
  }
}

export const documentTypesApi = new DocumentTypesApiService()
